import * as React from "react";
import { observer } from "mobx-react";
import { BetButtonsWrapRegular } from "../BetButtonsWrapRegular";
export const MarketsWrapRegular = observer((props) => {
    const buttonsHolderClass = props.details.event.cardType
        ? `rj-ev-list__${props.componentPrefix}__buttons-holder--${props.details.event.cardType.toLowerCase()}`
        : "";
    return (React.createElement("div", { className: `rj-ev-list__${props.componentPrefix}__buttons-holder ${buttonsHolderClass}`, "data-uat": `div-ev-list-${props.componentPrefix}-buttons-holder` },
        React.createElement(BetButtonsWrapRegular, { details: props.details, market: props.details.markets[0], componentPrefix: props.componentPrefix })));
});
//# sourceMappingURL=MarketsWrapRegular.js.map